/**
 * Default trash retention (days) — must match backend
 * `PLATFORM_TRASH_RETENTION_DAYS_DEFAULT` / `TRASH_RETENTION_DAYS` (default 30).
 */
export const PLATFORM_TRASH_RETENTION_DAYS = 30;

export function trashRetentionDaysFromPayload(
  payload: unknown,
  fallback: number = PLATFORM_TRASH_RETENTION_DAYS,
): number {
  const d = (payload as { trashRetentionDays?: number } | null)?.trashRetentionDays;
  return typeof d === 'number' && d > 0 ? d : fallback;
}

/**
 * Archive and delete use the same soft removal: the item goes to Archive & delete and
 * stays there until an admin permanently deletes it.
 *
 * TRASH-TRUTH-1: nothing purges on a schedule today. `PlatformRetentionCronService` is
 * registered in no module and `GET /admin/trash/retention-policy` returns
 * `automaticPurge: false`, so this line must not promise a number of days. The
 * `days` argument is kept so callers do not change; it is deliberately unused until a
 * retention policy actually purges (founder ruling R8, 8 Oct).
 */
export function archiveAndDeleteContainerSentence(days?: number): string {
  void days;
  return 'Goes to Archive & delete. An admin can restore it from Administration → Archive & delete until an admin permanently deletes it.';
}

/** User-facing line for delete → Archive & delete (soft delete; no automatic purge). */
export function trashRetentionDeleteSentence(days?: number): string {
  return archiveAndDeleteContainerSentence(days);
}

/**
 * User-facing line for archive. Archive IS delete: `archiveProject` calls `deleteProject`
 * (soft delete into Archive & delete), so the wording is the same on purpose.
 */
export function trashRetentionArchiveSentence(days?: number): string {
  return archiveAndDeleteContainerSentence(days);
}
